import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mm-part4',
  templateUrl: './part4.component.html',
  styleUrls: ['./part4.component.scss']
})
export class Part4Component implements OnInit {

  currentSection = 0;

  sections = [{
    id: 0,
    title: 'משחק אינטרנטי',
    img: 'internet.png',
    inDevelope: false
  },
  {
    id: 1,
    title: 'משחק טלפוני',
    img: 'phone.png',
    inDevelope: false
  },
  {
    id: 2,
    title: 'אירוע מרחוק',
    img: 'remote-event.png',
    inDevelope: false
  },
  {
    id: 3,
    title: 'אירוע משולב',
    img: 'combined-event.png',
    inDevelope: true
  }];

  readonly baseURL = './assets/images/part4/';

  constructor() { }

  ngOnInit(): void { }

}
